import { always, ifElse, isEmpty, not, pathOr } from 'ramda';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withAdvisorProfile from 'src/containers/advisorProfile.containers';
import { ApplicationState } from 'src/store/ApplicationState.d';
import { TodoAny } from 'src/types';
import { Account } from 'src/types/Account';
import { getFriendlyName } from 'src/utilities/friendlyNamer';
import { authenticatedUser, isAnsweringFor3rdPerson, primaryApplicantContext } from 'src/utilities/storage';
import AdvisorMenu from './AdvisorMenu';
import ApplicantMenu from './ApplicantMenu';
import {
  Header,
  HeaderContainer,
} from 'src/features/Auth/Header/Header.styles';
import { svgLogoUrl } from 'src/utilities/logo';
import HeaderAuthButton from 'src/components/Buttons/HeaderAuthButton';
import Box from '@mui/material/Box';
import { FakeButton, LogoImage } from 'src/components/Layouts/Layout.styles';
import { useLocation, useHistory } from 'react-router-dom';
import FDICBanner from 'src/components/Layouts/FDICBanner';
import { START_NEW, WORKFLOW_SIGNED_UP } from 'src/components/URLGaurd/contants';
import URLGaurd from 'src/components/URLGaurd';

interface WithAdvisorProps {
  advisor: any;
}

interface StateProps {
  loadingAdvisor?: string;
  accounts: Account;
}

interface Props {
  user: boolean;
  navWidth: '';
}

type CombinedProps = Props & StateProps & WithAdvisorProps;


const UserMenu: React.FC<CombinedProps> = (props: CombinedProps) => {
  const location = useLocation();
  const history = useHistory();

  const handleHome = () => {
    history.push('/');
  };

  const getAccountEmail = () => {
    const { accountEmail: applicantEmail } = primaryApplicantContext();
    const email = isAnsweringFor3rdPerson() ? applicantEmail : authenticatedUser.accountEmail.get();
    if (email === 'null') {
      handleHome();
      return 'Unknown user';
    }
    return email;
  };


  const renderUserMenu = () => {
    const accountEmail = getAccountEmail();
    const shortName = getFriendlyName();
    const { accounts, advisor } = props;
    const advisorId = pathOr('', ['id'], advisor);

    const pathname = pathOr('/', ['pathname'], location);
    return ifElse(
      compose(not, isEmpty),
      always(
        <AdvisorMenu
          userEmail={accountEmail}
          shortName={shortName}
          callback={pathname}
          accounts={accounts}
          advisorProfile={advisor}
        />
      ),
      always(
        <ApplicantMenu
          userEmail={accountEmail}
          shortName={shortName}
          callback={pathname}
        />
      )
    )(advisorId);
  };

  const renderLogo = () => {
    return <LogoImage src={svgLogoUrl()} alt="" />;
  };

  return (
    <Header>
      <Box>
        <URLGaurd urlRegexPatterns={[
          WORKFLOW_SIGNED_UP,
          START_NEW
        ]}>
          <FDICBanner />
        </URLGaurd>
      </Box>
      <HeaderContainer>
        <FakeButton />
        <Box>{renderLogo()}</Box>
        {props.user ? renderUserMenu() : <HeaderAuthButton />}
      </HeaderContainer>
    </Header>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    accounts: pathOr({}, ['accounts', 'data'], state),
  };
};

const connected = connect(mapStateToProps, undefined);
export default compose<TodoAny>(
  connected,
  withAdvisorProfile((ownProps, advisor, loading) => ({
    ...ownProps,
    advisor,
    loading,
  }))
)(UserMenu);